import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
export const MainContainer = ({ gridColumn, children }) => (_jsx(Box, { as: "div", display: "flex", flexDirection: "column", height: "auto", gridColumn: gridColumn, children: children }));
